import type { DefaultOptionType } from 'antd/es/select';
import { BaseService } from './base-service';
import {
	GetCustomReportsRequestDTO,
	GetCustomReportsResponseDTO,
	GetTotalReportsCreatedRequestDTO,
	GetTotalReportsCreatedResponseDTO,
	GetCustomReportByTypeListRequestDTO,
	GetCustomReportByTypeListResponseDTO
} from '@/core/dto/custom-reports';
import {
	GetCustomReportByTypeListMapper,
	GetTotalReportsCreatedMapper,
	GetCustomReportListMapper
} from '@/core/mapper/custom-reports';

export class CustomReportsService extends BaseService<GetCustomReportsResponseDTO> {
	private static instance: CustomReportsService;

	private constructor(public readonly basePath: string = '/custom-report') {
		super();
	}

	public static getInstance(): CustomReportsService {
		if (!CustomReportsService.instance) {
			CustomReportsService.instance = new CustomReportsService();
		}
		return CustomReportsService.instance;
	}

	public async findAll(params?: GetCustomReportsRequestDTO): Promise<DefaultOptionType[]> {
		const url = this.basePath + `/list/`;
		const { data } = await this.getInstance().get<GetCustomReportsResponseDTO[]>(url, { params });
		return new GetCustomReportListMapper(data).toDomain();
	}

	public async getTotalReportsCreated(
		params: GetTotalReportsCreatedRequestDTO
	): Promise<GetTotalReportsCreatedResponseDTO> {
		const url = this.basePath + `/list/types`;
		const { data } = await this.getInstance().get<GetTotalReportsCreatedResponseDTO>(url, { params });
		return new GetTotalReportsCreatedMapper(data).toDomain();
	}

	public async getCustomReportByTypeList(
		params: GetCustomReportByTypeListRequestDTO
	): Promise<GetCustomReportByTypeListResponseDTO> {
		const url = this.basePath + `/result/type/${params.custom_report_id}`;
		const { data } = await this.getInstance().get<GetCustomReportByTypeListResponseDTO>(url, { params });
		return new GetCustomReportByTypeListMapper(data).toDomain();
	}
}
